export const isManager = (user) => ["admin", "top_management"].includes(user?.role);
export const hasModule = (user, key) => user?.role === "admin" || (user?.modules?.[key] ?? true) !== false;
export const vaultViewOnly = (user) => !hasModule(user, "vault") && !!user?.vault_shared;
